import React, { Component } from "react";
import Table from '../../../components/UI/Table/Table'
import { updatePlanInMappingRequest } from '../action';
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { Button, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {
  displayErrorMessage,
  displaySuccessMessage,
} from '../../../Corporate/my-portfolio/monitoring/charts/monitoring-util';
import Modal from '../../../components/UI/Modal/Modal';

class EWSCounterpartyTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.tasks,
      ewsPlans: this.props.ewsPlans,
      masterChecked: false,
      updatePlanInMappingRes: null,
      confirmModal: false,
      sorted: {
        id: "counterpartyName",
        desc: true,
      },
      skip: 0,
      limit: 10,
      currentPage: 0
    };
  }

  componentDidMount = () => {
    this.isMasterChecked(this.props.tasks);
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.ewsPlans !== prevProps.ewsPlans) {
      // master plan list update
      let masterSelectPlan = document.getElementById("master-select-plan");
      let option = document.createElement("option");
      option.innerHTML = 'Select plan';
      masterSelectPlan.appendChild(option);

      this.props.ewsPlans.forEach(plan => {
        let option = document.createElement("option");
        option.value = plan.value;
        option.innerHTML = plan.label;
        masterSelectPlan.appendChild(option);
      })
    }

    if (this.props.tasks !== prevProps.tasks) {
      this.setState({
        data: this.props.tasks,
        masterChecked: this.isMasterChecked(this.props.tasks)
      });
    }

    if (this.props.updatePlanInMappingRes !== prevProps.updatePlanInMappingRes) {
      if (this.props.updatePlanInMappingRes.status === "SUCCESS") {
        if (this.props.updatePlanInMappingRes.data !== "")
          displaySuccessMessage("Plan has been changed Successfully!");
      } else {
        let message = this.props.updatePlanInMappingRes.data.message ? this.props.updatePlanInMappingRes.data.message : this.props.updatePlanInMappingRes.data;
        displayErrorMessage(message);
      }
    }
  }

  isMasterChecked = (data) => {
    if(data){
      const totalItems = data.length;
      const totalCheckedItems = data.filter((e) => e.ewsOptin);
      return totalItems === totalCheckedItems.length; 
    }else{
      return false;
    }
  }

  onMasterPlanChange = (e) => {
    this.props.onMasterPlanChange(e.target.value);
  }

  confirmModelForPlanChange = (e, cp) => {
    let planName = e.target.selectedOptions[0].label;
    let planId = e.target.value;

    this.setState((prevState) => ({
      confirmModal: !prevState.confirmModal,
      confirmModalBody: <div>
        <ModalHeader>Confirm Plan</ModalHeader>
        <ModalBody>
          <p><b>Are you sure changing plan for counterparty &#34;{cp.counterpartyName}&#34; to plan &#34;{planName}&#34;</b></p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={this.toggleconfirmModal}>Close</Button>
          <Button color="primary" onClick={this.handleCPPlanChange(planId, planName, cp)}>Proceed</Button>
        </ModalFooter>
      </div>
    }))
  }

  toggleconfirmModal = () => {
    this.setState((prevState) => ({
      confirmModal: !prevState.confirmModal
    }));
  }

  handleCPPlanChange = (e, cp) => {
    // handleCPPlanChange = (planId, planName,  cp) => {
    // this.toggleconfirmModal();
    cp.ewsPlans = [e.target.value];
    // cp.ewsPlans = [planId];
    if (e.target.value !== 'Select plan') {
      // if (planName !== 'Select plan') {        
      this.props.updatePlanInMappingRequest({
        corporateId: cp.corporateId,
        counterpartyId: cp.counterpartyId,
        planId: e.target.value
        // planId: planId
      });
      // displaySuccessMessage("Plan has been changed Successfully!");
    }
  }

  getFormattedPlan = (planIds) => {
    let tempPlans = this.state.ewsPlans;
    let index = tempPlans.findIndex(p => planIds.includes(p.value));
    return tempPlans[index];
  }

  onItemChecked = (e) => {
    let tempList = [...this.state.data];
    let index = tempList.findIndex(cp => (cp.corporateId + "|" + cp.counterpartyId) === e.target.value);
    let item = { ...tempList[index] };
    item.ewsOptin = e.target.checked;

    if (item.ewsOptin) {
      this.enableSelectPlanOnItemChecked(item);
    } else {
      this.disableSelectPlanOnItemUnchecked(item);
      item.ewsPlans = null;
    }

    this.props.updateCounterparties(item);

    tempList[index] = item;

    const totalItems = this.state.data.length;
    const totalCheckedItems = tempList.filter((e) => e.ewsOptin);

    this.setState({
      data: tempList,
      masterChecked: totalItems == totalCheckedItems.length,
    });
  }

  disableSelectPlanOnItemUnchecked = (cp) => {
    let selectPlan = document.getElementById(cp.corporateId + "|" + cp.counterpartyId);
    let options = selectPlan.getElementsByTagName("option");
    Array.from(options).forEach(option => {
      if (option.label === 'Select plan')
        option.selected = true;
    })
    selectPlan.disabled = true;
  }

  enableSelectPlanOnItemChecked = (cp) => {
    let selectPlan = document.getElementById(cp.corporateId + "|" + cp.counterpartyId);
    let masterSelect = document.getElementById("master-select-plan");
    let masterOptions = masterSelect.getElementsByTagName("option");
    let index = Array.from(masterOptions).findIndex(option => option.selected && option.label !== 'Select plan');
    if (index != -1) {
      let masterOption = masterOptions[index];
      let options = selectPlan.getElementsByTagName("option");
      Array.from(options).forEach(option => {
        if (option.value === masterOption.value) {
          cp.ewsPlans = [option.value];
          option.selected = true;
        }
      })
    }
    selectPlan.disabled = false;
  }

  onMasterChecked = (e) => {
    let tempList = [...this.state.data];

    if (e.target.checked) {
      tempList.forEach(cp => {
        cp.ewsOptin = e.target.checked;
        this.enableSelectPlanOnItemChecked(cp);
      })
      this.props.updateCounterparties(tempList);
    } else {
      let optOutList = [];
      tempList.forEach(cp => {
        cp.ewsOptin = e.target.checked;
        this.disableSelectPlanOnItemUnchecked(cp);
        if (cp.ewsPlans !== null) {
          optOutList.push(cp);
        }
      })
      this.props.updateCounterparties(optOutList);
    }

    this.setState({
      masterChecked: e.target.checked,
      data: tempList,
    });
  }

  resetPagination() {
    this.setState({
      currentPage: 0
    });
  }

  render() {
    const columns = [
      {
        Header: <p><input type="checkbox" checked={this.state.masterChecked} onChange={(e) => this.onMasterChecked(e)} /><br /></p>,
        id: "ewsOptin",
        accessor: p => <input type="checkbox" checked={p.ewsOptin} value={p.corporateId + "|" + p.counterpartyId} onChange={(e) => this.onItemChecked(e)} />,
        width: "5px"
      },
      {
        Header: <p>Counterparty Name<br /></p>,
        accessor: 'counterpartyName',
        width: 350
      },
      {
        Header: <p>PAN<br /></p>,
        id: "pan",
        accessor: p => p.pan ? p.pan : "NA",
        width: 150
      },
      {
        Header: <p>EWS Plan<br /><select className="select-style" id="master-select-plan"
          onChange={(e) => this.onMasterPlanChange(e)}>
        </select></p>,
        id: "cpPlan",
        accessor: p => <div>&nbsp;&nbsp;&nbsp;<select className="select-style"
          onChange={(e) => this.handleCPPlanChange(e, p)}
          id={p.corporateId + "|" + p.counterpartyId}
          disabled={!p.ewsPlans || !p.ewsOptin}>
          <option
            selected={!p.ewsPlans}>
            {"Select plan"}
          </option>
          {this.props.ewsPlans.map(({ value, label }, index) =>
            <option
              value={value}
              key={index}
              selected={p.ewsPlans && value === p.ewsPlans[0]}>
              {label}
            </option>)}
        </select></div>,
      },
      {
        Header: <p>EWS Count<br /></p>,
        id: "ewsCount",
        accessor: p => p.ewsCount ? p.ewsCount : "0",
        width: 150
      },
      {
        Header: <p>Country<br /></p>,
        accessor: "country",
        width: 100
      },
      {
        Header: <p>Portfolio<br /></p>,
        id: "portfolio",
        accessor: p => p.portfolio ? "Yes" : "No",
        width: 100
      }
    ]

    return (
      <div>
        <Table
          data={this.state.data ? this.state.data : []}
          columns={columns}
          // defaultSorted={[
          //   {
          //     id: "counterpartyName",
          //     desc: true,
          //   },
          // ]}
          className=""
          noDataText={this.props.selectedData ? "No counterparties found" : "Please select any corporate"}
          multiSort={false}
          // pages={this.props.noOfPages}
          // page={this.state.currentPage}
          defaultPageSize={10}
          showPagination={false}
          showPaginationTop={false}
          showPaginationBottom={true}
          manual // this would indicate that server side pagination has been enabled
          loading={this.props.loading}
        />
        <Modal show={this.state.confirmModal} className='Modal shadow-none confirm-modal' >
          {this.state.confirmModalBody}
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  updatePlanInMappingRes: state.ews.updatePlanInMappingRes,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  updatePlanInMappingRequest: (data) => { dispatch(updatePlanInMappingRequest(data)) },
})

export default reduxForm({
  form: ' EWSCounterpartyTable'
})(connect(mapStateToProps, mapDispatchToProps)(EWSCounterpartyTable))